import { useRoutes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";

import { MatxTheme } from "./components";
// ALL CONTEXTS
import { AuthProvider } from "./contexts/JWTAuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import SettingsProvider from "./contexts/SettingsContext";
import TenantHostProvider from "./tenant/TenantHostProvider";
import TenantBrandingApplier from "./tenant/TenantBrandingApplier";
// ROUTES
import routes from "./routes";
// FAKE SERVER
import "../fake-db";
// Language
import "../i18n";

import useAxiosInterceptor from "app/hooks/useAxiosInterceptor";

export default function App() {
  useAxiosInterceptor();
  const content = useRoutes(routes);

  return (
    <SettingsProvider>
      <TenantHostProvider>
        <AuthProvider>
          <NotificationProvider>
            <MatxTheme>
              <CssBaseline />
              <TenantBrandingApplier />
              {content}
            </MatxTheme>
          </NotificationProvider>
        </AuthProvider>
      </TenantHostProvider>
    </SettingsProvider>
  );
}
